import { FC } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import Loader from 'react-loader-spinner';

import RenderTeamRoomSnap from '../render-team-room-snap';
import Styled from '../../styles';

import colors from '../../../../assets/colors';
import { useUtils } from '../../../../core/hooks/useUtils';
import { loadMoreMineTeamRoomsAction } from '../../../../store/MineTeamRooms/action';

const MyTeamRoomsList: FC<{ activeTab: string }> = ({ activeTab }) => {
	const {
		dispatch,
		store: {
			mineTeamRooms: { data, isLoading, page, totalPages },
		},
	} = useUtils();

	const HAS_MORE = page < totalPages;

	const loadMore = () => {
		if (isLoading) return;

		dispatch(loadMoreMineTeamRoomsAction(page + 1));
	};

	return (
		<InfiniteScroll
			loadMore={loadMore}
			threshold={750}
			hasMore={HAS_MORE}
			loader={
				<Styled.LoaderWrapper key={0}>
					<Loader type="TailSpin" color={colors.blue} height={50} width={50} />
				</Styled.LoaderWrapper>
			}
		>
			<RenderTeamRoomSnap data={data} activeTab={activeTab} />
		</InfiniteScroll>
	);
};

export default MyTeamRoomsList;
